import { UserPlus as AddUser } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconAddUser12Line = createIcon(AddUser, 12, "Line");
export const IconAddUser16Line = createIcon(AddUser, 16, "Line");
export const IconAddUser20Line = createIcon(AddUser, 20, "Line");
export const IconAddUser24Line = createIcon(AddUser, 24, "Line");
export const IconAddUser32Line = createIcon(AddUser, 32, "Line");
export const IconAddUser48Line = createIcon(AddUser, 48, "Line");
export const IconAddUser64Line = createIcon(AddUser, 64, "Line");
